import {ValueObject} from '@s-ui/domain'

export class VehiclesListValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array} params.items
   * */
}
